export class PersonSelectChild {
	constructor(parent, parentNode, value, counter) {
		this.parent = parent;
		this.parentNode = parentNode;
		this.wrapperClassName = 'c-tk-person-selector__children-wrapper';
		this.value = value || null;
		this.values = parentNode.dataset.values.split(", ");
		this.valuesLabel = parentNode.dataset.valuesLabel;
		this.node = null;
		this.wrapper = null;
		this.label = null;
		this.select = document.createElement('select');
		this.selectWrapper = document.createElement('div');
		this.counter = counter;
		this.ageLabels = parentNode.dataset.ageLabels.split(", ");

		if (!value) {
			return;
		}

		this.init();
	}

	getNode() {
		return this.node;
	}

	init() {
		const self = this;
		this.node = self.createChild();
		this.select.addEventListener('change', this.handleSelectChange.bind(this));

		self.parentNode.appendChild(this.node);
	}

	createChild() {
		let wrapper = document.createElement('div');
		wrapper.classList.add(this.wrapperClassName);

		wrapper.appendChild(this.createLabel());
		wrapper.appendChild(this.createSelectWrapper());

		this.wrapper = wrapper;

		return wrapper;
	}

	createLabel() {
		let label = document.createElement('div');
		let labelText = this.parentNode.dataset.label || '';
		const numberOfParentChildren = this.parentNode.querySelectorAll(`.${this.wrapperClassName}`).length;

		// label.textContent = labelText.replace('{age}', numberOfParentChildren + 1);
		label.textContent = this.ageLabels[numberOfParentChildren];

		this.label = label;

		return label;
	}

	createSelectWrapper() {
		const self = this;

		let selectWrapper = self.selectWrapper;
		selectWrapper.classList.add('c-selectbox');
		selectWrapper.classList.add('c-form-block__input');
		selectWrapper.classList.add('js-selectbox');
		selectWrapper.dataset.selectid = `children-age[${self.counter}]`;

		selectWrapper.appendChild(this.createSelect());

		self.selectWrapper = selectWrapper;

		return self.selectWrapper;
	}

	createSelect() {
		const self = this;

		let select = self.select;
		select.classList.add('c-selectbox__select');
		select.id = `children-age[${self.counter}]`;
		select.name = `children-age[${self.counter}]`;

		// Create options
		this.values.forEach(defaultValue => {
			let option = document.createElement('option');
			option.value = defaultValue;
			option.textContent = self.valuesLabel.replace('{age}', defaultValue);

			if (defaultValue === self.value) {
				option.setAttribute('selected', true);
			}

			select.appendChild(option);
		});

		self.select = select;
		self.select.value = this.value;

		return self.select;
	}

	handleSelectChange() {
		const self = this;

		const event = new CustomEvent('selectChange', {
			detail: { value: self.select.value }
		})

		self.select.dispatchEvent(event);
	}

	onSelectChange(callback) {
		this.select.addEventListener('change', callback);
	}

	getSelect() {
		return this.select;
	}

	getSelectWrapper() {
		return this.wrapper;
	}
}
